export const mountData = [
  {
    id: "1",
    name: "Zeqalotl",
    type: "mount",
    rarity: "NA",
    isTradable: false,
    content: null,
    model: "/cosmetic/model/mounts/1.gltf",
    preview: "/cosmetic/preview/mounts/1.webp",
    obtain: ["Purchasable on store.zeqa.net", "Elite Rank"],
  },
  {
    id: "2",
    name: "Go-Kart",
    type: "mount",
    rarity: "NA",
    isTradable: false,
    content: null,
    model: "/cosmetic/model/mounts/2.gltf",
    preview: "/cosmetic/preview/mounts/2.webp",
    obtain: ["Purchasable on store.zeqa.net", "Elite Rank"],
  },
  {
    id: "3",
    name: "Stingray",
    type: "mount",
    rarity: "NA",
    isTradable: false,
    content: null,
    model: "/cosmetic/model/mounts/3.gltf",
    preview: "/cosmetic/preview/mounts/3.webp",
    obtain: ["Purchasable on store.zeqa.net", "Elite Rank"],
  },
  {
    id: "4",
    name: "Hamlet",
    type: "mount",
    rarity: "NA",
    isTradable: false,
    content: null,
    model: "/cosmetic/model/mounts/4.gltf",
    preview: "/cosmetic/preview/mounts/4.webp",
    obtain: ["Purchasable on store.zeqa.net", "Elite Rank"],
  },
];
